import {scroller} from "react-scroll";
import styled from "@emotion/styled";

import {Button as DSButton} from "@pg-design/button-module";

export const RegisterCompanyButton = () => {
    const onScrollToForm = () => {
        scroller.scrollTo("zarejestruj-firme", {smooth: true});
    };

    return (
        <Button onClick={onScrollToForm} variant="filled_primary">
            Zarejestruj firmę
        </Button>
    );
};

const Button = styled(DSButton)`
    min-width: 22rem;
`;
import {scroller} from "react-scroll";
import styled from "@emotion/styled";

import {Button as DSButton} from "@pg-design/button-module";

export const RegisterCompanyButton = () => {
    const onScrollToForm = () => {
        scroller.scrollTo("zarejestruj-firme", {smooth: true});
    };

    return (
        <Button onClick={onScrollToForm} variant="filled_primary">
            Zarejestruj firmę
        </Button>
    );
};

const Button = styled(DSButton)`
    min-width: 22rem;
`;
